import { useEffect, useState } from 'react'

export default function FloorplanControls({ floorplanState, setFloorplanState, planTypeOptions = [] }) {
  const { currentFilterOption, currentPlan, sitePlanZoomActive } = floorplanState
  const plans = floorplanData.plans || []

  const getOptionValue = option => {
    if (typeof option === 'object' && option !== null) {
      return option.value
    }

    return option
  }

  const getOptionLabel = option => {
    if (typeof option === 'object' && option !== null) {
      return option.label || option.value
    }

    return option
  }

  const getMobilePlanTypeLabel = option => {
    const optionLabel = String(getOptionLabel(option) || '')

    return optionLabel.replace(/\bbedroom\b/gi, 'bed')
  }

  const getPlanTypeValue = plan => getOptionValue(plan?.plan_type)

  const [mobilePlanTypeValue, setMobilePlanTypeValue] = useState(
    getPlanTypeValue(currentPlan) ?? getOptionValue(planTypeOptions[0]) ?? null
  )

  useEffect(() => {
    const currentPlanTypeValue = getPlanTypeValue(currentPlan)

    if (!currentPlanTypeValue) {
      return
    }

    setMobilePlanTypeValue(currentPlanTypeValue)
  }, [currentPlan])

  const sortedPlans = [...plans].sort((a, b) => String(a.title).localeCompare(String(b.title)))

  const groupedPlans = planTypeOptions.map(option => {
    const optionValue = getOptionValue(option)
    const optionPlans = sortedPlans.filter(plan => getOptionValue(plan.plan_type) === optionValue)

    return {
      option,
      optionValue,
      plans: optionPlans
    }
  })

  const mobileVisiblePlans = sortedPlans.filter(
    plan => getPlanTypeValue(plan) === mobilePlanTypeValue
  )

  const selectedFilterLabel =
    typeof currentFilterOption === 'object' && currentFilterOption !== null
      ? currentFilterOption.label || currentFilterOption.value
      : currentFilterOption

  return (
    <>
      <div className="floorplan-controls-desktop d-none d-md-block">
        <h2>Select a Plan to View</h2>

        {groupedPlans.map(group => (
          <div className="plan-group" key={group.optionValue}>
            <h3>{getOptionLabel(group.option)}</h3>
            <ul>
              {group.plans.map(plan => (
                <li key={plan.id}>
                  <button
                    type="button"
                    className={`btn btn-circle-primary-outline ${currentPlan?.id === plan.id ? 'active' : ''}`}
                    onClick={() => setFloorplanState({ currentPlan: plan })}
                  >
                    {plan.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="floorplan-controls-mobile d-md-none">
        <h3>View Plans:</h3>

        <div className="plan-type-buttons">
          {planTypeOptions.map(option => {
            const optionValue = getOptionValue(option)
            const isActive = optionValue === mobilePlanTypeValue

            return (
              <button
                key={optionValue}
                type="button"
                className={`plan-type-button ${isActive ? 'active' : ''}`}
                onClick={() => setMobilePlanTypeValue(optionValue)}
              >
                {getMobilePlanTypeLabel(option)}
              </button>
            )
          })}
        </div>

        <ul className="mobile-plan-links">
          {mobileVisiblePlans.map(plan => (
            <li key={plan.id}>
              <button
                type="button"
                className={`btn btn-circle-primary-outline ${currentPlan?.id === plan.id ? 'active' : ''}`}
                onClick={() => setFloorplanState({ currentPlan: plan })}
              >
                {plan.title}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}